import Container from './Container';

export default Container;



// WEBPACK FOOTER //
// ./src/components/shared/Container/index.js